import React from "react";
import { ReturnStatsRow, ReturnHistogram } from "./ReturnDistributionStats";

interface Props {
  distribution: ForwardDistribution;
  forecastWindow: number;
  window: number;
}

export default function ForwardDistribution({ distribution, forecastWindow }: Props) {
  const { count, returns } = distribution;

  if (!count) return null;

  return (
    <div className="forward-curve-section">
      <h3 className="forward-curve-title">
        What Happened Next
        <span className="forward-curve-subtitle">
          {count} historical analogs · {forecastWindow}-day forward return
        </span>
      </h3>

      <div style={{ maxWidth: 640 }}>
        <ReturnStatsRow distribution={distribution} />
      </div>
      <ReturnHistogram returns={returns} />
    </div>
  );
}
